/**
 * A bool that can be undefined
 */
export enum EUndefinedBool {
  UB_Undefined,
  UB_False,
  UB_True,
}
